import * as React from 'react';

import { IJKInfo } from '../../../types/results';
import { Text } from '../../Text';

export interface IIJKInfoProps {
  jkInfo: IJKInfo;
}

export function JKInfo({ jkInfo }: IIJKInfoProps) {
  const { deadlineText, floorText, materialTypeText } = jkInfo;

  return (
    <>
      {deadlineText && (
        <div>
          <Text textSize="small" color="gray">
            {deadlineText}
          </Text>
        </div>
      )}
      {floorText && (
        <div>
          <Text textSize="small" color="gray">
            {floorText}
          </Text>
        </div>
      )}
      {materialTypeText && (
        <div>
          <Text textSize="small" color="gray">
            {materialTypeText}
          </Text>
        </div>
      )}
    </>
  );
}
